import { Injectable } from '@angular/core';
import { EERROR_BUTTON_EVENT, IErrorComponentData } from '@app/core/models/error.model';
import { ErrorsType } from '@app/domain/store/error/error.state';
import { Store } from '@ngrx/store';
import * as errorActions from '@store/error/error.actions';
import * as errorSelectors from '@store/error/error.selectors';
import * as appActions from '@store/app/app.actions';
import * as appSelectors from '@store/app/app.selectors';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ErrorFacade {
  public errorComponentData$: Observable<IErrorComponentData>;
  public isLoading$: Observable<boolean>;

  constructor(private _store: Store) {
    this.errorComponentData$ = this._store.select(errorSelectors.selectErrorComponentData);
    this.isLoading$ = this._store.select(errorSelectors.selectIsLoading);
  }

  public handleError(
    message: string,
    errorType?: ErrorsType,
    hasCard?: boolean,
    hadValidLoan?: boolean,
    callback?: Function,
    componentData?: IErrorComponentData
  ) {
    this._store.dispatch(
      errorActions.handleError({
        message,
        errorType,
        callback,
        componentData,
        hasCard,
        hadValidLoan,
      })
    );
  }

  public showError(
    message: string,
    errorType,
    callback,
    componentData?: IErrorComponentData,
    hasCard?: boolean,
    hadValidLoan?: boolean
  ) {
    this._store.dispatch(
      errorActions.showError({
        message,
        errorType,
        callback,
        componentData,
        hasCard,
        hadValidLoan,
      })
    );
  }

  public showErrorComponent(errorComponentData: IErrorComponentData) {
    this._store.dispatch(errorActions.showErrorComponent({ errorComponentData }));
  }

  public errorButtonEvent(buttonEvent: EERROR_BUTTON_EVENT) {
    this._store.dispatch(errorActions.controlErrorButtonEvent({ buttonEvent }));
  }

  public setCountResendOTPCode(countResendOTPCode: number): void {
    this._store.dispatch(errorActions.setCountResendOTPCode({ countResendOTPCode }));
  }

  public increaseCountResendOTPCode(): void {
    this._store.dispatch(errorActions.increaseCountResendOTPCode());
  }
}
